var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTextCheck = function SvgTextCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.43 16H10V18H31.43C31.6952 18 31.9496 17.8946 32.1371 17.7071C32.3246 17.5196 32.43 17.2652 32.43 17C32.43 16.7348 32.3246 16.4804 32.1371 16.2929C31.9496 16.1054 31.6952 16 31.43 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.43 24H10V26H31.43C31.6952 26 31.9496 25.8946 32.1371 25.7071C32.3246 25.5196 32.43 25.2652 32.43 25C32.43 24.7348 32.3246 24.4804 32.1371 24.2929C31.9496 24.1054 31.6952 24 31.43 24Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4502 10H31.4502C31.7154 10 31.9698 9.89464 32.1573 9.70711C32.3448 9.51957 32.4502 9.26522 32.4502 9C32.4502 8.73478 32.3448 8.48043 32.1573 8.29289C31.9698 8.10536 31.7154 8 31.4502 8H17.4502L15.4502 10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 3.41997C17.3984 3.31747 17.2777 3.2361 17.1446 3.18056C17.0116 3.12503 16.8689 3.09644 16.7247 3.09644C16.5806 3.09644 16.4379 3.12503 16.3048 3.18056C16.1718 3.2361 16.0511 3.31747 15.9497 3.41997L7.88973 11.48L4.50973 7.83997C4.31082 7.62647 4.03524 7.50073 3.74362 7.49042C3.452 7.4801 3.16823 7.58605 2.95473 7.78497C2.74123 7.98388 2.6155 8.25946 2.60518 8.55108C2.59487 8.8427 2.70082 9.12647 2.89973 9.33997L7.83973 14.64L17.4997 4.99997C17.6056 4.89741 17.6897 4.77464 17.7472 4.63893C17.8047 4.50322 17.8343 4.35734 17.8343 4.20997C17.8343 4.06259 17.8047 3.91671 17.7472 3.78101C17.6897 3.6453 17.6056 3.52252 17.4997 3.41997Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text-check.02a6d1eb.svg";
export { ForwardRef as ReactComponent };